import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import './plugins/smoothscroll'
import App from './App.vue'
import router from './router'

import VueSilentbox from 'vue-silentbox'
import store from './store'

Vue.use(VueSilentbox)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
